import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

function getLocalizedNews() {
  const languageData = [];
  const setstate = {
    showError: false,
    loading: false,
    hideBar: false,
  };
  const newsList = Storages.MainStorage.getItem(StorageKeys.Keys.LATESTNEWS);
  const languageId = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGEID);
  if (newsList !== null && newsList.length) {
    newsList.forEach((element, index) => {
      const locale_var = element.latestnews_desc_locale.filter(
        (local) => local.language_id === languageId 
      );
      if (locale_var.length > 0) {
        languageData.push({
          latest_news: element.title,
          locale_latest_news: locale_var[0],
          id: locale_var[0].id,
          logo: element.logo_url || null,
          is_site_news: element.site_news
        });
        setstate.hideBar = true;
      } else {
        setstate.showError = true;
        setstate.loading = true;
      }
    });
  }
  if (newsList === null || newsList.length === 0) {
    setstate.showError = true;
    setstate.hideBar = true;
  }
  return { setstate, languageData };
}

export default getLocalizedNews;
